import React from "react";
import {CrmContact, ContactRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import FormToggle from "../../../../components/form/form_inputs/form_toggle";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {types} from "../../../../components/form/types";

export const ContactEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(ContactRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getContact(id),
        updater: (bean) => ctrl.saveContact(bean),
        remover: (id) => ctrl.deleteOrDismissContact(id),
        factory: () => ({} as CrmContact),
    } as UseFormProps<CrmContact>);

    return (
        <FormContent form={form} title={"Formulario de contacto"}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"name"} label={"Nombre"}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"surnames"} label={"Apellidos"}/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormAutocomplete field={"organization"} label={"Organización"} type={types.organizations}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormSelect field={"type"} label={"Tipo"} type={types.contactTypes}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormInput field={"position"} label={"Cargo"}/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"email"} label={"Email"} type="email"/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"phone"} label={"Teléfono"}/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"linkedin"} label={"LinkedIn"}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormToggle field={"noDisturb"} label={"No molestar"}/>
                    <FormToggle field={"securityContact"} label={"Contacto de incidentes"}/>
                </Grid>
            </Grid>

            {/* Base legal del correo comercial (#13647, LSSI art. 21). El boletín solo va a
                CONSENT, que exige fecha y origen; una baja es OPTED_OUT y gana a todo. Vacío =
                sin revisar. Reglas: arteco-docs/procesos/marketing/wf-outbound-leads.md. */}
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <FormSelect field={"commercialEmailBasis"} label={"Base legal del correo"} type={types.commercialEmailBases}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormInput field={"commercialEmailBasisDate"} label={"Desde"} type="date"/>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <FormInput field={"commercialEmailBasisSource"} label={"Origen de la base legal"}/>
                </Grid>
            </Grid>

            <FormInput field={"observation"} label={"Observaciones"} rows={4}/>
        </FormContent>
    );
};
